import React, { useState, useEffect } from 'react';
import {
  Button,
  TextField,
  Tooltip,
  Container,
  Typography,
  InputAdornment,
  Box,
  Table,
  Modal,
  styled,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Brand = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddBrandModal, setShowAddBrandModal] = useState(false);
  const [showEditBrandModal, setShowEditBrandModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [mainCategory, setMainCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [brand, setBrand] = useState('');
  const [description, setDescription] = useState('');
  const [selectedBrand, setSelectedBrand] = useState({
    brandId: null,
    mainCategory: '',
    subCategory: '',
    brand: '',
    description: '',
  });

  // Static data for brands and dropdowns
  const staticMainCategoryData = [
    { mainCategoryId: 1, mainCategory: 'Electronics' },
    { mainCategoryId: 2, mainCategory: 'Clothing' },
    { mainCategoryId: 3, mainCategory: 'Books' },
    { mainCategoryId: 4, mainCategory: 'Home & Kitchen' },
    { mainCategoryId: 5, mainCategory: 'Sports' },
    { mainCategoryId: 6, mainCategory: 'Toys' },
  ];

  const staticSubCategoryData = {
    'Electronics': [
      { subCategoryId: 1, subCategory: 'Smartphones' },
      { subCategoryId: 2, subCategory: 'Laptops' },
    ],
    'Clothing': [
      { subCategoryId: 3, subCategory: 'Men' },
      { subCategoryId: 4, subCategory: 'Women' },
    ],
    'Books': [
      { subCategoryId: 5, subCategory: 'Fiction' },
      { subCategoryId: 6, subCategory: 'Non-Fiction' },
    ],
    'Home & Kitchen': [
      { subCategoryId: 7, subCategory: 'Appliances' },
      { subCategoryId: 8, subCategory: 'Furniture' },
    ],
    'Sports': [
      { subCategoryId: 9, subCategory: 'Outdoor' },
      { subCategoryId: 10, subCategory: 'Indoor' },
    ],
    'Toys': [
      { subCategoryId: 11, subCategory: 'Educational' },
      { subCategoryId: 12, subCategory: 'Action Figures' },
    ],
  };

  const staticBrandData = [
    { brandId: 1, mainCategory: 'Electronics', subCategory: 'Smartphones', brand: 'Samsung', description: 'Mobile phones and accessories' },
    { brandId: 2, mainCategory: 'Electronics', subCategory: 'Laptops', brand: 'Dell', description: 'Laptops and notebooks' },
    { brandId: 3, mainCategory: 'Clothing', subCategory: 'Men', brand: 'Nike', description: 'Clothing for men' },
    { brandId: 4, mainCategory: 'Clothing', subCategory: 'Women', brand: 'Adidas', description: 'Clothing for women' },
    { brandId: 5, mainCategory: 'Books', subCategory: 'Fiction', brand: 'Penguin', description: 'Fiction books' },
    { brandId: 6, mainCategory: 'Books', subCategory: 'Non-Fiction', brand: 'HarperCollins', description: 'Non-fiction books' },
  ];

  const [brands, setBrands] = useState(staticBrandData);
  const [filteredData, setFilteredData] = useState(staticBrandData);

  const handleAddBrand = () => {
    setMainCategory('');
    setSubCategory('');
    setBrand('');
    setDescription('');
    setShowAddBrandModal(true);
  };

  const handleEdit = (brandItem) => {
    setSelectedBrand({
      brandId: brandItem.brandId,
      mainCategory: brandItem.mainCategory,
      subCategory: brandItem.subCategory,
      brand: brandItem.brand,
      description: brandItem.description,
    });
    setMainCategory(brandItem.mainCategory);
    setSubCategory(brandItem.subCategory);
    setBrand(brandItem.brand);
    setDescription(brandItem.description);
    setShowEditBrandModal(true);
  };

  const handleShowDeleteModal = (brandId, brandName) => {
    setSelectedBrand({ brandId, brand: brandName });
    setShowDeleteModal(true);
  };

  const handleDelete = () => {
    setBrands((prevBrands) =>
      prevBrands.filter((brandItem) => brandItem.brandId !== selectedBrand.brandId)
    );
    setSnackbarMessage(`${selectedBrand.brand} deleted successfully!`);
    setSnackbarSeverity('success');
    setOpenSnackbar(true);
    setShowDeleteModal(false);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (mainCategory && subCategory && brand && description) {
      const newBrand = {
        brandId: brands.length + 1,
        mainCategory,
        subCategory,
        brand,
        description,
      };
      setBrands([...brands, newBrand]);
      setShowAddBrandModal(false);
       setSnackbarMessage('Saved successfully!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
      setMainCategory('');
      setSubCategory('');
      setBrand('');
      setDescription('');
    } else {
      setSnackbarMessage('Please fill all fields');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleUpdate = () => {
    if (mainCategory && subCategory && brand && description) {
      const updatedBrands = brands.map((brandItem) =>
        brandItem.brandId === selectedBrand.brandId
          ? { ...brandItem, mainCategory, subCategory, brand, description }
          : brandItem
      );
      setBrands(updatedBrands);
      setShowEditBrandModal(false);
       setSnackbarMessage('Updated successfully!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
      setMainCategory('');
      setSubCategory('');
      setBrand('');
      setDescription('');
    } else {
      setSnackbarMessage('Please fill all fields');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleReset = () => {
    setMainCategory('');
    setSubCategory('');
    setBrand('');
    setDescription('');
  };

  const handleCancel = () => {
    setShowEditBrandModal(false);
    setMainCategory('');
    setSubCategory('');
    setBrand('');
    setDescription('');
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  useEffect(() => {
    setFilteredData(
      brands.filter(
        (brandItem) =>
          brandItem.mainCategory.toLowerCase().includes(searchTerm.toLowerCase()) ||
          brandItem.subCategory.toLowerCase().includes(searchTerm.toLowerCase()) ||
          brandItem.brand.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, brands]);

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:'space-between',
          mb: 1,
          p: 2,
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{display :'flex',justifyContent:'center',alignItems:'center',gap:2}}>
        <TextField
                           variant="outlined"
                           placeholder="Search..."
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                           InputProps={{
                             startAdornment: (
                               <InputAdornment position="start">
                                 <SearchIcon
                                   sx={{
                                     color: theme.palette.primary.main,
                                     marginLeft: 1.5,
                                     fontSize: 24,
                                   }}
                                 />
                               </InputAdornment>
                             ),
                             endAdornment: searchTerm && (
                               <InputAdornment position="end">
                                 <IconButton
                                   size="small"
                                   onClick={() => setSearchTerm('')}
                                   sx={{
                                     color: "grey",
                                     marginRight: 1,
                                   }}
                                 >
                                   <CloseIcon fontSize="small" />
                                 </IconButton>
                               </InputAdornment>
                             ),
                             sx: {
                               borderRadius: '30px',
                               backgroundColor: theme.palette.mode === 'dark'
                                 ? 'rgba(255, 255, 255, 0.15)'
                                 : 'rgba(255, 255, 255, 1)',
                               boxShadow: theme.palette.mode === 'dark'
                                 ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                 : '0 2px 8px rgba(0, 0, 0, 0.1)',
                               '& .MuiOutlinedInput-notchedOutline': {
                                 border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                               },
                               '&:hover': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.2)'
                                   : 'rgba(240, 240, 240, 1)',
                                 boxShadow: theme.palette.mode === 'dark'
                                   ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                   : '0 2px 12px rgba(0, 0, 0, 0.15)',
                               },
                               '&.Mui-focused': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.25)'
                                   : 'rgba(255, 255, 255, 1)',
                                 boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                 '& .MuiOutlinedInput-notchedOutline': {
                                   border: `2px solid ${theme.palette.primary.main}`,
                                 },
                               },
                               paddingLeft: 1.5,
                               height: '50px',
                               transition: 'all 0.3s ease',
                             },
                           }}
                           sx={{
                             width: 350,
                             maxWidth: '100%',
                             '& .MuiInputBase-input': {
                               padding: '10px 14px',
                               color: theme.palette.text.primary,
                               fontWeight: 500,
                             },
                           }}
                         />
          <Button
            variant="contained"
            onClick={handleAddBrand}
            sx={{
              ml: 2,
              width: '100px',
              borderRadius:'10px',
              height: '50px',
              padding: '10px 0',
              fontWeight: 'bold',
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.dark },
            }}
            startIcon={<AddIcon />}
          >
            ADD
          </Button>
          </Box>
          <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={() => setShowUserGuideModal(true)}
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              minWidth: 0, // Remove MUI's default padding
            }}
          >
            <InfoOutlineIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
      </Box>

      <Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Main Category</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Sub Category</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Brand</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Description</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((brandItem, index) => (
                    <TableRow
                      key={brandItem.brandId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{brandItem.mainCategory}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{brandItem.subCategory}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{brandItem.brand}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{brandItem.description}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => handleEdit(brandItem)}
                          sx={{
                            color: theme.palette.primary.light,
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleShowDeleteModal(brandItem.brandId, brandItem.brand)}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}>
                    <TableCell colSpan={6} align="center" sx={{ fontSize: '1rem', padding: '20px',wordSpacing:7}}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>

      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>
                Rows
              </InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Delete Modal */}
      <Modal
        open={showDeleteModal}
        onClose={handleCloseDeleteModal}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete <strong>{selectedBrand.brand}</strong>?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Add Brand Modal */}
      <Modal
        open={showAddBrandModal}
        onClose={() => setShowAddBrandModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 500,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Brand
            </Typography>
            <IconButton onClick={() => setShowAddBrandModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel id="main-category-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                Main Category
              </InputLabel>
              <Select
                labelId="main-category-label"
                id="main-category"
                value={mainCategory}
                label="Main Category"
                onChange={(e) => {
                  setMainCategory(e.target.value);
                  setSubCategory('');
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticMainCategoryData.map((category) => (
                  <MenuItem key={category.mainCategoryId} value={category.mainCategory}>
                    {category.mainCategory}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel id="sub-category-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                Sub Category
              </InputLabel>
              <Select
                labelId="sub-category-label"
                id="sub-category"
                value={subCategory}
                label="Sub Category"
                onChange={(e) => setSubCategory(e.target.value)}
                disabled={!mainCategory}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {mainCategory &&
                  staticSubCategoryData[mainCategory]?.map((subCat) => (
                    <MenuItem key={subCat.subCategoryId} value={subCat.subCategory}>
                      {subCat.subCategory}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <TextField
              label="Brand"
              variant="outlined"
              fullWidth
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={!mainCategory || !subCategory || !brand || !description ? "Enter all fields" : ""} arrow>
                <span>
                  <Button
                    variant="contained"
                    onClick={handleSave}
                    sx={{
                      mr: 2,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.dark },
                    }}
                    disabled={!mainCategory || !subCategory || !brand || !description}
                  >
                    SAVE
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Edit Brand Modal */}
      <Modal
        open={showEditBrandModal}
        onClose={handleCancel}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 500,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Brand
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel id="main-category-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                Main Category
              </InputLabel>
              <Select
                labelId="main-category-label"
                id="main-category"
                value={mainCategory}
                label="Main Category"
                onChange={(e) => {
                  setMainCategory(e.target.value);
                  setSubCategory('');
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticMainCategoryData.map((category) => (
                  <MenuItem key={category.mainCategoryId} value={category.mainCategory}>
                    {category.mainCategory}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel id="sub-category-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                Sub Category
              </InputLabel>
              <Select
                labelId="sub-category-label"
                id="sub-category"
                value={subCategory}
                label="Sub Category"
                onChange={(e) => setSubCategory(e.target.value)}
                disabled={!mainCategory}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {mainCategory &&
                  staticSubCategoryData[mainCategory]?.map((subCat) => (
                    <MenuItem key={subCat.subCategoryId} value={subCat.subCategory}>
                      {subCat.subCategory}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <TextField
              label="Brand"
              variant="outlined"
              fullWidth
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={!mainCategory || !subCategory || !brand || !description ? "Enter all fields" : ""} arrow>
                <span>
                  <Button
                    variant="contained"
                    onClick={handleUpdate}
                    sx={{
                      mr: 2,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.dark },
                    }}
                    disabled={!mainCategory || !subCategory || !brand || !description}
                  >
                    UPDATE
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Success Modal */}
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {showAddBrandModal ? 'Brand Added ✅' : 'Brand Updated ✅'}
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              {showAddBrandModal ? 'Brand Added Successfully' : 'Brand Updated Successfully'}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={showUserGuideModal}
        onClose={() => setShowUserGuideModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Brand Management - User Guide
            </Typography>
            <IconButton
              onClick={() => setShowUserGuideModal(false)}
              sx={{ color: '#fff', position: 'absolute', right: 14 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
 <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
  {/* Section 1: Add Characteristic */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
  >
    ➤ Follow these steps to add a new characteristic:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Click the <strong>"ADD"</strong> button at the top right to open the Add Characteristics modal.
    </li>
    <li>
      Select a <strong>Main Category</strong> from the dropdown menu.
    </li>
    <li>
      Select a <strong>Sub Category</strong>; available options depend on the selected Main Category.
    </li>
    <li>
      Select a <strong>Brand</strong>; available options depend on the selected Sub Category.
    </li>
    <li>
      Enter the <strong>Characteristic</strong> details in the provided text field.
    </li>
    <li>
      Before clicking the <strong>"SAVE"</strong> button, review all entered information to ensure accuracy.
    </li>
    <li>
      Click the <strong>"SAVE"</strong> button to add the characteristic. A success message will confirm the addition.
    </li>
    <li>
      The newly added characteristic will appear in the Characteristics List table.
    </li>
    <li>
      If you want to reset the form, click the <strong>"RESET"</strong> button to clear all fields and close the modal.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Main Category, Sub Category, Brand, and Characteristics are required fields.
  </Typography>

  {/* Section 2: Edit Characteristic */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to update an existing characteristic:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Select the characteristic you want to edit from the Characteristics List table.
    </li>
    <li>
      Click the <strong>Edit</strong> icon (pencil) in the Action column to open the Edit Characteristics modal.
    </li>
    <li>
      Update the <strong>Main Category</strong>, <strong>Sub Category</strong>, <strong>Brand</strong>, or <strong>Characteristics</strong> as required.  
      (Selections are interdependent.)
    </li>
    <li>
      Before clicking the <strong>"UPDATE"</strong> button, ensure all required fields are filled.
    </li>
    <li>
      Click the <strong>"UPDATE"</strong> button to save the changes. A success message will confirm the update.
    </li>
    <li>
      To discard changes, click the <strong>"CANCEL"</strong> button to close the modal.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Main Category, Sub Category, Brand, and Characteristics are required fields.
  </Typography>

  {/* Section 3: Delete Characteristic */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to delete a characteristic:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Select the characteristic you want to delete from the Characteristics List table.
    </li>
    <li>
      Click the <strong>Delete</strong> icon (trash) in the Action column.
    </li>
    <li>
      Confirm the deletion in the confirmation modal by clicking <strong>"Yes, Delete"</strong>.
    </li>
    <li>
      The characteristic will be permanently removed, and a success message will appear.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Deleted characteristics cannot be recovered. Proceed with caution.
  </Typography>

  {/* Section 4: Search Characteristics */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to search for a characteristic:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Use the search bar at the top left of the Characteristics List.
    </li>
    <li>
      Enter the Main Category, Sub Category, Brand, or Characteristic name (or part of it).
    </li>
    <li>
      The table will automatically update to display matching results.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Search is case-insensitive and applies across all characteristic fields.
  </Typography>

  {/* Section 5: Pagination */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to navigate the characteristics list:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Use the pagination controls at the bottom of the table.
    </li>
    <li>
      Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
    </li>
    <li>
      Click a specific page number to jump directly to that page.
    </li>
    <li>
      Adjust the number of rows per page using the dropdown (e.g., 5, 10, 25, or 50 rows).
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Only the selected number of rows per page will be displayed in the table.
  </Typography>
</CustomTableScrollbar>


        </Box>
      </Modal>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default Brand;